import { EBlockchain } from 'multirpc-sdk';

export type TxHash = `0x${string}`;

export enum ECryptoDepositStep {
  Allowance = 1,
  Deposit,
}

export enum ECryptoDepositStepStatus {
  Complete = 1,
  Confirming,
  Error,
  Initializing,
  Pending,
}

export enum ECurrency {
  ANKR = 'ANKR',
  USD = 'USD',
  USDT = 'USDT',
  USDC = 'USDC',
}

export enum EPaymentType {
  OneTime = 'one-time',
  Recurring = 'recurring',
  Deal = 'deal',
}

export const DEAL_UPGRADE_PAYMENT_TYPE = 'deal-upgrade';

type TDealUpgradePaymentType = typeof DEAL_UPGRADE_PAYMENT_TYPE;

export type TPaymentTypeExtended = EPaymentType | TDealUpgradePaymentType;

export type TStablecoinCurrency = ECurrency.USDC | ECurrency.USDT;

export type TCryptoCurrency = TStablecoinCurrency | ECurrency.ANKR;

export interface IFeeDetails {
  feeCrypto: number;
  feeUSD: number;
}

export interface INetwork {
  blockchain: EBlockchain;
}

export const PaymentCurrency = {
  usd: 'USD',
  ankr: 'ANKR',
  stableCoin: 'STABLECOIN',
} as const;

export type TPaymentCurrency =
  typeof PaymentCurrency[keyof typeof PaymentCurrency];

export interface IPaymentFormValues {
  paymentType: EPaymentType;
  currency: TPaymentCurrency;
  oneTimeUsdAmount: string;
  oneTimeAnkrAmount: string;
  oneTimeStableCoinAmount: string;
  stableCoinCurrency: TStablecoinCurrency;
  dealAmount: string;
  recurringAmount: string;
  currencyChain: EBlockchain;

  // two additional fields is needed to use amount validation
  // including token balance
  amountAnkr: string;
  amountStableCoin: string;
}
